module.exports = __webpack_public_path__ + "static/media/FSFhorizontalLogo.d37e7e8b.svg";